import { Image, Link } from '@akinon/next/components';
import { ImageItem } from './type';

export const Banner = ({
  image,
  isDesktop
}: {
  image: ImageItem;
  isDesktop: boolean;
}) => {
  if (!image?.value || !image?.kwargs) return null;

  const imageUrl = image?.kwargs?.value?.image?.url;
  const linkUrl = image?.value?.url || null;
  const altText = image?.value?.alt || '';
  const aspectRatio = image?.value?.aspect_ratio || 1;

  if (!imageUrl) return null;

  const ImageElement = (
    <Image
      src={imageUrl}
      alt={altText}
      aspectRatio={aspectRatio}
      width={isDesktop ? 870 : 375}
      height={isDesktop ? 500 : 200}
      unoptimized
      crop="none"
      className={
        isDesktop ? 'hidden lg:block w-full h-auto' : 'lg:hidden w-full h-auto'
      }
      imageClassName="w-full"
    />
  );

  return linkUrl ? (
    <Link href={linkUrl} className="flex items-center justify-center w-full">
      {ImageElement}
    </Link>
  ) : (
    <div className="flex items-center justify-center w-full">
      {ImageElement}
    </div>
  );
};
